"use client";

import React, { useState } from "react";
import Image from "next/image";
import svgPaths from "@/assets/svg/svg-5s97axwnwx";
import imgImage34 from "@/assets/images/landing/4a88318460322cc5e0461d97af7b5d4a60027fe6.png";
import imgImage35 from "@/assets/images/landing/316db7e18f2c6469e2b864dd65b286c9ffed230a.png";
import imgImage36 from "@/assets/images/landing/1fbe4faf3baf8258ccec16cbafa92154aaee3c0a.png";

export default function MobileFeatureShowcase() {
	const [activeCard, setActiveCard] = useState<number | null>(null);

	const baseCardClasses =
		"backdrop-blur-md bg-[rgba(255,255,255,0.05)] rounded-2xl overflow-hidden border transition-all duration-300 transform";

	const getCardClasses = (index: number) => {
		const isActive = activeCard === index;
		const borderClass = isActive
			? "border-[#A7FF5E]/60 shadow-[0_0_0_1px_rgba(167,255,94,0.4)] shadow-brand scale-[1.02]"
			: "border-[rgba(255,255,255,0.25)] scale-100";
		return `${baseCardClasses} ${borderClass}`;
	};

	const handleCardClick = (index: number) => {
		setActiveCard((current) => (current === index ? null : index));
	};

	return (
		<div className="flex flex-col gap-6 mb-8">
			<button
				type="button"
				onClick={() => handleCardClick(0)}
				className={getCardClasses(0)}
			>
				<div className="relative h-52 w-full">
					<Image
						src={imgImage34}
						alt="Map View"
						fill
						className="object-cover"
					/>
				</div>
				<div className="p-6 flex flex-col gap-5">
					<div className="w-[73px] h-14 rounded-full bg-[#3d5b47] border-4 border-[#14291d] flex items-center justify-center overflow-hidden">
						<svg
							className="w-20 h-12"
							fill="none"
							viewBox="0 0 81 51"
						>
							<path d={svgPaths.p21b4f480} fill="#1D712E" />
							<path d={svgPaths.p1bf36d00} fill="#29E150" />
							<path
								d={svgPaths.p37f4dc80}
								fill="url(#paint0_linear_169_7708)"
							/>
							<circle
								cx="17.382"
								cy="16.8477"
								fill="#A7FF5E"
								r="5.6"
								stroke="#A7FF5E"
								strokeWidth="1"
							/>
							<defs>
								<linearGradient
									gradientUnits="userSpaceOnUse"
									id="paint0_linear_169_7708"
									x1="18.9862"
									x2="18.9862"
									y1="0"
									y2="50.2733"
								>
									<stop stopColor="#2AD64E" />
									<stop offset="1" stopColor="#167029" />
								</linearGradient>
							</defs>
						</svg>
					</div>
					<div className="flex-1">
						<h3
							className="text-[#edffde] font-bold text-base leading-6 mb-2"
							style={{ textAlign: "left" }}
						>
							Pin point properties with map view
						</h3>
						<p
							className="text-[rgba(255,255,255,0.7)] text-base leading-6"
							style={{ textAlign: "left" }}
						>
							Browse property by asking price using map view.
						</p>
					</div>
				</div>
			</button>

			{/* Property View Feature */}
			<button
				type="button"
				onClick={() => handleCardClick(1)}
				className={getCardClasses(1)}
			>
				<div className="relative h-52 w-full">
					<Image
						src={imgImage35}
						alt="Property View"
						fill
						className="object-cover rounded-t-2xl"
					/>
				</div>
				<div className="p-6 flex flex-col gap-5">
					<div className="w-[73px] h-14 rounded-full bg-[#3d5b47] border-4 border-[#14291d] flex items-center justify-center overflow-hidden shrink-0">
						<svg
							className="w-20 h-12"
							fill="none"
							viewBox="0 0 81 64"
						>
							<rect
								fill="#3D5B47"
								height="56"
								rx="28"
								width="72.9167"
								x="4"
								y="4"
							/>
							<path d={svgPaths.p31f54af0} fill="#29E150" />
							<path d={svgPaths.p558a240} fill="#29E150" />
							<path d={svgPaths.p30b68600} fill="#1B5B30" />
							<path d={svgPaths.p3fb9fd00} fill="#1B5B30" />
							<path d={svgPaths.p39777c30} fill="#25BC45" />
							<path d={svgPaths.p26c5da00} fill="#25BC45" />
							<path d={svgPaths.p10f2bf00} fill="#A7FF5E" />
							<path d={svgPaths.p26c48d00} fill="#173D29" />
							<path d={svgPaths.p22041a00} fill="#A7FF5E" />
							<path d={svgPaths.p1fb96700} fill="#173D29" />
							<rect
								height="60"
								rx="30"
								stroke="#14291D"
								strokeWidth="4"
								width="76.9167"
								x="2"
								y="2"
							/>
						</svg>
					</div>
					<div className="flex-1">
						<h3
							className="text-[#edffde] font-bold text-base leading-6 mb-2"
							style={{ textAlign: "left" }}
						>
							With Property view, quickly view the property you
							want and export easily
						</h3>
					</div>
					<div className="flex flex-col gap-3">
						{/* Bullet 1 - Search by address, county and more */}
						<div className="flex items-start gap-3">
							<svg
								className="w-5 h-5 shrink-0 mt-0.5"
								fill="none"
								viewBox="0 0 20 20"
							>
								<path
									d={svgPaths.p22fdb270}
									stroke="#A7FF5E"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="1.67"
								/>
							</svg>
							<p
								className="text-white text-base leading-5"
								style={{ textAlign: "left" }}
							>
								Search by address, county and more
							</p>
						</div>
						{/* Bullet 2 - Quick Filters */}
						<div className="flex items-start gap-3">
							<svg
								className="w-5 h-5 shrink-0 mt-0.5"
								fill="none"
								viewBox="0 0 20 20"
							>
								<path
									d={svgPaths.p1cd34800}
									stroke="#A7FF5E"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="1.67"
								/>
							</svg>
							<p className="text-white text-base leading-5">
								Quick Filters
							</p>
						</div>
						{/* Bullet 3 - Export */}
						<div className="flex items-start gap-3">
							<svg
								className="w-5 h-5 shrink-0 mt-0.5"
								fill="none"
								viewBox="0 0 20 20"
							>
								<path
									d={svgPaths.p3d8d99e0}
									stroke="#A7FF5E"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="1.67"
								/>
							</svg>
							<p className="text-white text-base leading-5">
								Export
							</p>
						</div>
					</div>
				</div>
			</button>

			{/* Calendar View Feature */}
			<button
				type="button"
				onClick={() => handleCardClick(2)}
				className={getCardClasses(2)}
			>
				<div className="relative h-52 w-full">
					<Image
						src={imgImage36}
						alt="Calendar View"
						fill
						className="object-cover rounded-t-2xl"
					/>
				</div>
				<div className="p-6 flex flex-col gap-5">
					<div className="w-14 h-14 rounded-full flex items-center justify-center backdrop-blur-md shrink-0">
						<svg
							className="block size-full"
							fill="none"
							viewBox="0 0 56 56"
						>
							<path
								d={svgPaths.p26d12a20}
								fill="black"
								fillOpacity="0.05"
							/>
							<path
								d={svgPaths.p26d12a20}
								fill="#65DE9E"
								fillOpacity="0.12"
							/>
							<path d={svgPaths.p3571fc00} fill="white" />
						</svg>
					</div>
					<div className="flex-1">
						<h3
							className="text-[#edffde] font-bold text-base leading-6 mb-2"
							style={{ textAlign: "left" }}
						>
							Use calendar view to plan ahead and view auction
							schedule
						</h3>
						<p
							className="text-[rgba(255,255,255,0.7)] text-base leading-6"
							style={{ textAlign: "left" }}
						>
							With calendar view, quickly see when properties will
							go to auction.
						</p>
					</div>
				</div>
			</button>
		</div>
	);
}
